var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group col-12"},[_c('label',[_vm._v("Audio")]),_c('media-chooser',{attrs:{"value":_vm.audio,"type":"audio"},on:{"input":_vm.onAudioChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }